import mobileCarousel from '../utils/mobileCarousel';

mobileCarousel(
    'image-links-section__mobile-carousel',
    'swiper-pagination-image-links-section',
    1.4,
    16
);
